import { Component, Input, Output, EventEmitter } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-report-footer',
  templateUrl: './report-footer.component.html'
})
export class ReportFooterComponent {
  @Input() today: Date = new Date();
  @Input() loadingDownload = false;
  @Input() loadingShare = false;
  @Output() download = new EventEmitter<void>();
  @Output() recalculate = new EventEmitter<void>();
  @Output() share = new EventEmitter<string>();

  email = '';

  openModal(): void {
    $('#rptShareModal').modal('show');
  }

  closeModal(): void {
    $('#rptShareModal').modal('hide');
    this.email = '';
  }

  onSend(): void {
    this.share.emit(this.email);
  }
}
